module.exports = __webpack_public_path__ + "img/11.bf4f248d.png";